import JustificativaFalta from "@/Pages/JustificativaFalta/index.vue";
import JustificativaFaltaPortalAluno from "@/Pages/JustificativaFalta/justificativaFaltaPortalAluno.vue";
import permitirRoles from "./guards/permitirRoles";

const ROLES_PERMITIDOS = [
  "aluno",
  "secretario",
  "secretario-escolar",
  "coordenador",
  "direção",
  "admin",
  "super-admin",
];

const guard = permitirRoles(ROLES_PERMITIDOS);

export default [
  {
    path: "/justificativa-falta/index",
    name: "justificativaFalta.index",
    component: JustificativaFalta,
    beforeEnter: guard,
  },
  {
    path: "/justificativa-falta/portal",
    name: "justificativaFalta.portal",
    component: JustificativaFaltaPortalAluno,
    beforeEnter: guard,
  },
];
